import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { LabelM, SubtitleM } from "./Typography";

export default function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title,
  content,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "600px",
          maxWidth: "100%",
          boxSizing: "border-box",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle sx={{ pb: 0 }}>
        <LabelM>{title}</LabelM>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <SubtitleM style={{ textAlign: "center", fontWeight: "400" }}>
          {content}
        </SubtitleM>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0, justifyContent: "space-around" }}>
        <Button onClick={onClose} variant="SecondaryButton">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="PrimaryButton" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
